import { mapFinalCalculation, RawFinalCalculation } from './mapFinalCalculation';
import { mapProduct, RawProduct } from './mapProduct';
import { Reference } from './Reference';
import { SkMaxPrice } from './SkMaxPrice';

export interface RawSkMaxPrice {
	readonly reference: {
		readonly packageSize: number;
		readonly historicProductDataViewDate: string | null;
		readonly referenceBasketVersion: string;
		readonly priceComparisonFxDate: string | null;
	};
	readonly products: RawProduct[];
	readonly finalCalculation: RawFinalCalculation;
	readonly _links: { readonly [key: string]: string };
}

export function mapSkMaxPrice(skMaxPrice: RawSkMaxPrice): SkMaxPrice {
	return new SkMaxPrice(
		new Reference(
			skMaxPrice.reference.packageSize,
			skMaxPrice.reference.historicProductDataViewDate !== null
				? new Date(skMaxPrice.reference.historicProductDataViewDate)
				: null,
			skMaxPrice.reference.referenceBasketVersion,
			skMaxPrice.reference.priceComparisonFxDate !== null ? new Date(skMaxPrice.reference.priceComparisonFxDate) : null
		),
		skMaxPrice.products.map(mapProduct),
		mapFinalCalculation(skMaxPrice.finalCalculation),
		skMaxPrice._links
	);
}
